import './applianceManualsAndDocuments.scss';

import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useTranslation } from 'react-i18next';

import { GetDocDisplayName } from '../../utils';
import { IAppliance } from '../../interfaces';
import downloadIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Download-icon.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export default function ApplianceManualsAndDocuments(props: {
    appliance: IAppliance;
    warrantyDocument: string;
}) {
    const { appliance, warrantyDocument } = props;
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation('layout');
    const { heatingAreaDocument, govCreditData } = useStaticQuery(graphql`
        query {
            heatingAreaDocument: allProductsJson(
                filter: { code: { eq: "englander_carte-superficie-chauffage" } }
            ) {
                nodes {
                    title {
                        en_US
                        fr_CA
                    }
                    documents {
                        en_US
                        fr_CA
                    }
                }
            }
            govCreditData: allProductsJson(
                filter: {
                    code: {
                        eq: "US-Tax-Credit-Manufacturer-s-certificate-of-qualification-Englander"
                    }
                }
            ) {
                nodes {
                    documents {
                        en_US
                    }
                    attributes {
                        url {
                            values {
                                en_US
                            }
                        }
                        bouttons {
                            values {
                                en_US
                            }
                        }
                    }
                }
            }
        }
    `);

    const govCreditUsa = govCreditData?.nodes[0];
    const showHeatingAreaDocument = () => {
        return appliance.category === '/Englander/Heaters/Pellet Stoves/' ||
            appliance.category == '/Englander/Heaters/Wood Stoves/' ||
            appliance.category == '/Englander/Heaters/Wood Inserts/'
            ? true
            : false;
    };

    const sortedDocuments: any[] = [];
    appliance?.documents?.map((document: any) => {
        const displayName = GetDocDisplayName(document, appliance.code);
        let priority = Number.MAX_VALUE;
        if (
            displayName?.toLowerCase()?.indexOf('manual') >= 0 ||
            displayName?.toLowerCase()?.indexOf('manuel') >= 0
        ) {
            priority = 3;
        }

        switch (displayName) {
            case t('document.bilingual-user'):
            case t('document.install-user'):
            case t('document.user-manual'):
                priority = 1;
                break;
            case t('document.bilingual-install'):
            case t('document.manual'):
                priority = 2;
                break;
            case t('document.dimensions'):
                priority = 4;
                break;
            default:
                break;
        }
        sortedDocuments.push({
            displayName: displayName,
            document: document,
            priority: priority,
        });
    });

    sortedDocuments.sort((a: any, b: any) => {
        if (a.priority === b.priority && a.displayName < b.displayName) {
            return -1;
        } else if (a.priority === b.priority && a.displayName > b.displayName) {
            return 1;
        }
        return a.priority - b.priority;
    });

    console.log(heatingAreaDocument.nodes[0].documents[0]);

    return (
        <div className='appliance-manuals-and-documents-container'>
            <div className='appliance-banner'>
                {t('appliance.manual-and-documents')}
            </div>
            <div className='appliance-manuals'>
                {sortedDocuments?.map((sortedDocument) => {
                    return (
                        <a
                            className='manual-button'
                            key={sortedDocument?.document[currentLocale]}
                            href={
                                '/file/' +
                                sortedDocument?.document[currentLocale]
                            }
                            target='_blank'
                            rel='noreferrer'
                        >
                            {sortedDocument?.displayName}
                            <img src={downloadIcon} alt='' />
                        </a>
                    );
                })}
                <div className='line' />
                {showHeatingAreaDocument() && (
                    <a
                        className='document-button'
                        rel='noreferrer'
                        target='_blank'
                        href={`/file/${heatingAreaDocument.nodes[0].documents[0][currentLocale == 'fr_CA' ? 'fr_CA' : 'en_US']}`}
                    >
                        {
                            heatingAreaDocument.nodes[0].title[
                                currentLocale == 'fr_CA' ? 'fr_CA' : 'en_US'
                            ]
                        }
                        <img src={downloadIcon} alt='' />
                    </a>
                )}
                <a
                    className='document-button'
                    rel='noreferrer'
                    target='_blank'
                    href={`/file/${warrantyDocument}`}
                >
                    {t('appliance.download-warranty')}
                    <img src={downloadIcon} alt='' />
                </a>
                {currentLocale === 'en_US' &&
                    (() => {
                        const externalUrl =
                            govCreditUsa?.attributes?.url?.values?.[0]?.[
                                currentLocale
                            ];

                        const fileUrl = externalUrl
                            ? externalUrl
                            : '/file/' +
                              govCreditUsa?.documents?.[0]?.[currentLocale];

                        const buttonText =
                            govCreditUsa?.attributes?.bouttons?.values?.[0]?.[
                                currentLocale
                            ];

                        return (
                            <a
                                className='document-button'
                                rel='noreferrer'
                                target='_blank'
                                href={fileUrl}
                            >
                                <span>{buttonText}</span>
                                <img src={downloadIcon} alt='' />
                            </a>
                        );
                    })()}
            </div>
        </div>
    );
}
